import { generateClient } from 'aws-amplify/api';

const api = generateClient();

export default api;
